module.exports = __webpack_public_path__ + "assets/img/帮助.64b52279.svg";